import { render, staticRenderFns } from "./MainNotice.vue?vue&type=template&id=cf2357d8&scoped=true&"
import script from "./MainNotice.vue?vue&type=script&lang=js&"
export * from "./MainNotice.vue?vue&type=script&lang=js&"
import style0 from "./MainNotice.vue?vue&type=style&index=0&id=cf2357d8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf2357d8",
  null
  
)

export default component.exports